export function TargetResidentIcon({ size = 32 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <g id="pin-alt">
      <path id="Ellipse" d="M26.6667 13.3333C26.6667 19.2244 16 29.3333 16 29.3333C16 29.3333 5.33333 19.2244 5.33333 13.3333C5.33333 7.4423 10.109 2.66667 16 2.66667C21.891 2.66667 26.6667 7.4423 26.6667 13.3333Z" stroke="currentColor" strokeWidth="1.5"/>
      <path id="Vector" d="M16 14.6667C16.7364 14.6667 17.3333 14.0697 17.3333 13.3333C17.3333 12.597 16.7364 12 16 12C15.2636 12 14.6667 12.597 14.6667 13.3333C14.6667 14.0697 15.2636 14.6667 16 14.6667Z" fill="currentColor" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
    </svg>
  )
}
